export const REABO = 1
export const UPGRADE = 2

export const CONTRAT_FLOTTE_TYPE = 1

export const withCurrency = price => `${Number(price).toLocaleString()} XAF`
